import React, { useCallback } from 'react';
import { useSnackbar } from 'notistack';

import { IntlMsg } from '../../components/_core/IntlMsg/intl-msg.component';
import { messages } from '../../components/_core/OfflineHandler/offline-handler.messages';
import { useSnackbarDismissAction } from './use-snackbar-dismiss-action';

export const SCORE_STILL_SAVING_SNACKBAR_KEY = 'score-still-saving';

// One shared notice while any score write is still pending past a storage bound. A failed write is
// reported separately by the failure snackbar; this only says "keep waiting".
export const useScoreStillSavingSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const dismissAction = useSnackbarDismissAction();

  return useCallback((stillSaving: boolean) => {
    if (!stillSaving) {
      closeSnackbar(SCORE_STILL_SAVING_SNACKBAR_KEY);
      return;
    }
    enqueueSnackbar(<IntlMsg {...messages.scoreStillSaving} />,
      { key: SCORE_STILL_SAVING_SNACKBAR_KEY, variant: 'warning', persist: true, action: dismissAction });
  }, [enqueueSnackbar, closeSnackbar, dismissAction]);
};
